import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUserData } from '../hooks';
import styles from './PublicNav.module.css';

const PublicNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { userData, loading } = useUserData();

  // Show a "Home" link on every public page except the landing page itself.
  const isHome = location.pathname === '/';

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.logo} onClick={() => navigate('/')}>
          <img
            src="/vates-domus-ai-removebg-preview.png?v=1"
            alt="Vates Domus AI"
            onError={(e) => {
              console.error('Logo image failed to load');
              e.target.style.display = 'none';
            }}
          />
        </div>
        <nav className={styles.nav}>
          {!isHome && <a href="/">Home</a>}
          <a href="/pricing">Pricing</a>
          <a href="/faq">FAQ</a>
          <a href="/contact">Contact</a>
          <a href="/about">About Us</a>
          {loading ? (
            <button className={styles.authBtn} disabled>
              Loading...
            </button>
          ) : userData ? (
            <button
              className={styles.authBtn}
              onClick={() => navigate('/app/mls-gpt')}
            >
              {userData.firstName}'s Dashboard
            </button>
          ) : (
            <button
              className={styles.authBtn}
              onClick={() => navigate('/signin')}
            >
              Sign In
            </button>
          )}
        </nav>

        {/* Mobile Hamburger Menu */}
        <div className={styles.mobileMenuToggle} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <div className={`${styles.hamburger} ${isMobileMenuOpen ? styles.hamburgerActive : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className={styles.mobileMenuOverlay} onClick={() => setIsMobileMenuOpen(false)}>
          <div className={styles.mobileMenuContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.mobileNavLinks}>
              {!isHome && <a href="/" onClick={() => setIsMobileMenuOpen(false)}>Home</a>}
              <a href="/pricing" onClick={() => setIsMobileMenuOpen(false)}>Pricing</a>
              <a href="/faq" onClick={() => setIsMobileMenuOpen(false)}>FAQ</a>
              <a href="/contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</a>
              <a href="/about" onClick={() => setIsMobileMenuOpen(false)}>About Us</a>
              {loading ? (
                <button className={styles.mobileAuthBtn} disabled>
                  Loading...
                </button>
              ) : userData ? (
                <button
                  className={styles.mobileAuthBtn}
                  onClick={() => {
                    navigate('/app/mls-gpt');
                    setIsMobileMenuOpen(false);
                  }}
                >
                  {userData.firstName}'s Dashboard
                </button>
              ) : (
                <button
                  className={styles.mobileAuthBtn}
                  onClick={() => {
                    navigate('/signin');
                    setIsMobileMenuOpen(false);
                  }}
                >
                  Sign In
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default PublicNav;
